import { inject } from "@angular/core";

import { MenuTab } from "@models";
import { ActionService } from "@services";

export abstract class AbstractTabComponent {
  protected readonly acS = inject(ActionService);

  protected close(event: Event, back: boolean = false): void {
    event.stopPropagation();

    this.acS.mS$.set(back ? { tab: MenuTab.M } : null);
  }
}
